export default function ($translate) {
    return {
        KEYS: {
            EMPLOYEE: 'EMPLOYEE',
            TRAINER: 'TRAINER',
            DIRECT_MANAGER: 'DIRECT_MANAGER',
            API_USER: 'API_USER'
        },
        LABELS: {
            EMPLOYEE: $translate.instant('role.code.employee'),
            TRAINER: $translate.instant('role.code.trainer'),
            DIRECT_MANAGER: $translate.instant('role.code.direct_manager'),
            API_USER: $translate.instant('role.code.api_user')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/role/code/index.js